import { useEffect, useRef, useState } from 'react'

import { useHeight } from "@web-solutions/core/hooks/use-height"

const TOP_GAP = 20

type Params = {
  isAvailable?: boolean
  additionalHeight?: number
}

export const useGetMaxSOModalHeight = ({ isAvailable = true, additionalHeight = 0 }: Params = {}) => {
  const ref = useRef<HTMLDivElement>(null)

  const deviceHeight = useHeight() - TOP_GAP
  const [modalHeight, setModalHeight] = useState(0)

  useEffect(() => {
    if (ref.current && isAvailable) {
      const contentHeight = ref.current.offsetHeight + additionalHeight

      setModalHeight(contentHeight > deviceHeight ? deviceHeight : contentHeight)
    }
  }, [ref.current?.offsetHeight, deviceHeight, additionalHeight, isAvailable])

  return { ref, modalHeight }
}